module.exports = __webpack_public_path__ + "static/media/target_audience.8f5c5400.svg";